import { render, staticRenderFns } from "./novoCliente.vue?vue&type=template&id=4df068f3&"
import script from "./novoCliente.vue?vue&type=script&lang=js&"
export * from "./novoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports